import { RootState } from 'src/types';

export const paramsQuoteDetailSelector = (state: RootState) => state.params.params;